import { connect } from 'react-redux';
// actions
import { updateDeal } from '../../../redux/actions/deal-actions';
import { addDealContact, fetchDealContacts, updateDealContact, deleteDealContact } from '../../../redux/actions/deal-contacts-actions';

import TenantInformation from './TenantInformationTab';

const mapStateToProps = state => ({
  deal: state.deal.deal,
  voucher: state.voucher.voucher,
  contactInfo: state.dealContacts.contacts,
});

const mapDispatchProps = {
  updateDeal,
  addDealContact,
  fetchDealContacts,
  updateDealContact,
  deleteDealContact,
};

const TenantInformationContainer = connect(
  mapStateToProps,
  mapDispatchProps,
)(TenantInformation);

export default TenantInformationContainer;
